import http from "@/libs/axios";

export function getApartments(params) {
  return http.get("apartment/apartment/", { params });
}

export function getApartmentsByObject(params) {
  return http({
    method: "GET",
    url: `objects/${params.id}/apartments/`,
    params,
  });
}

export function getShortApartmentsByObject(params) {
  return http({
    method: "GET",
    url: `objects/${params.id}/apartments/`,
    params,
  });
}

export function createApartment(data) {
  return http.post("apartments/", data);
}

export function updateApartment(data) {
  return http.patch(`apartments/${data.id || data.get("id")}/`, data);
}

export function getSingleApartment(id) {
  return http.get(`apartments/${id}/`);
}

export function getCheckerBoardLayout(id) {
  return http.get(`apartments/${id}/chess/`);
}

export function getFlatsPlannings(id) {
  return http({
    method: "GET",
    url: `apartments/${id}/planning_list/`,
  });
}

export function getRoomsCountByApartment(id) {
  return http({
    method: "GET",
    url: `apartments/${id}/count_of_rooms/`,
  });
}

export function getBadges() {
  return http({
    method: "GET",
    url: "apartments/badge/",
  });
}

export function bookFlat(data) {
  return http({
    method: "POST",
    url: "clients/contract/bron_flat/",
    data,
  });
}

export function unbronFlat(bron_id) {
  return http({
    method: "DELETE",
    url: "clients/contract/unbron_flat/",
    params: { bron_id },
  });
}
